import { Divider, Typography } from '@material-ui/core';
import { TitleFieldProps } from '@rjsf/utils';

export const TitleFieldTemplate = (props: TitleFieldProps) => {
  return props?.title ? (
    <>
      <Typography variant="h4">{props.title}</Typography>
      <Divider />
    </>
  ) : (
    <></>
  );
};
